
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import { VForm } from '@/types/Components';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('patient', ['patientData', 'loaders']),
        },
        methods: {
            ...mapActions('patient', ['updateDekurs']),
        },
    })
    export default class DekursDetail extends Vue {
        @Prop() visible!: boolean;

        public $refs!: {
            form: VForm;
        };

        public patientData!: Patient;
        public updateDekurs!: (payload: { patnr: number; dekurs: string | null }) => void;

        public isNew = true;
        public dekurs: string | null = null;

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.isNew = false;
                this.dekurs = '';
            }
        }

        public onClickSave(): void {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.updateDekurs({
                patnr: this.patientData.patnr as number,
                dekurs: this.dekurs
            });
        }
    }
